<template>
  <b-toast id="toast" :title="toastOptions.title" :variant="toastOptions.variant" auto-hide>
    {{ toastOptions.text }}
  </b-toast>
</template>

<script>
export default {
  name: "Toast",
  props: {
    toastOptions: {
      type: Object
    }
  },
}
</script>

<style scoped>

</style>